/* eslint-disable */
/* tslint:disable */
// @ts-nocheck
/*
 * ---------------------------------------------------------------
 * ## THIS FILE WAS GENERATED VIA SWAGGER-TYPESCRIPT-API        ##
 * ##                                                           ##
 * ## AUTHOR: acacode                                           ##
 * ## SOURCE: https://github.com/acacode/swagger-typescript-api ##
 * ---------------------------------------------------------------
 */

import { ErrorResponse, I18NImportLogDTO, Language } from "./data-contracts";
import { ContentType, HttpClient, RequestParams } from "./http-client";

export class I18NImport<
  SecurityDataType = unknown,
> extends HttpClient<SecurityDataType> {
  /**
   * @description Returns the last 100 i18n import-protocol entries, most recent first
   *
   * @tags I18n Import
   * @name GetImportLog1
   * @summary Get import log
   * @request GET:/api/admin/i18n/import-log
   * @secure
   */
  getImportLog1 = (params: RequestParams = {}) =>
    this.request<I18NImportLogDTO[], ErrorResponse>({
      path: `/api/admin/i18n/import-log`,
      method: "GET",
      secure: true,
      ...params,
    });
  /**
   * @description Returns a single i18n import-protocol entry with all its structured findings
   *
   * @tags I18n Import
   * @name GetImportLogDetail
   * @summary Get import log detail
   * @request GET:/api/admin/i18n/import-log/{id}
   * @secure
   */
  getImportLogDetail = (id: number, params: RequestParams = {}) =>
    this.request<I18NImportLogDTO, ErrorResponse | I18NImportLogDTO>({
      path: `/api/admin/i18n/import-log/${id}`,
      method: "GET",
      secure: true,
      ...params,
    });
  /**
   * @description Validates and, if structurally sound, applies an uploaded XLSX language file to the persistent i18n store for the given language — all-or-nothing
   *
   * @tags I18n Import
   * @name ImportLanguage
   * @summary Import language file
   * @request POST:/api/admin/i18n/{language}/import
   * @secure
   */
  importLanguage = (
    language: Language,
    data: {
      /** @format binary */
      file: File;
    },
    params: RequestParams = {},
  ) =>
    this.request<I18NImportLogDTO, ErrorResponse>({
      path: `/api/admin/i18n/${language}/import`,
      method: "POST",
      body: data,
      secure: true,
      type: ContentType.FormData,
      ...params,
    });
}
